<script setup lang="ts">
import PromotionWithPeriod from 'theme/components/atoms/PromotionWithPeriod.vue';
import { useIsInIframe } from '~/components/templates/_lp/PartnerPontaTemplate/composables/useIsInIframe';

const { isInIframe } = useIsInIframe();
const target = computed((): string => {
  return isInIframe ? '_blank' : '_self';
});
const rel = computed(() => {
  return isInIframe ? 'noopener' : undefined;
});
</script>

<template>
  <section :class="$style.section">
    <h2 :class="$style.title">Pontaポイントの受領方法について</h2>
    <div
      :class="[
        $style.section__contents,
        $style['section__contents--text'],
        $style.description,
      ]"
    >
      <PromotionWithPeriod
        :starts-at="new Date('2023-10-01T00:00:00+09:00')"
        :lasts-until="new Date('2024-01-01T00:00:00+09:00')"
      >
        <h3>◆概要</h3>
        <p>
          オカネコ for
          Pontaに会員登録をし、本ページから毎月5問以上リアルタイムアンケートに回答で、5Pontaポイントをプレゼントいたします。
        </p>
        <h3>◆ポイント獲得条件</h3>
        <ol>
          <li>
            【STEP1】まずはオカネコ for Pontaの会員登録を完了<br />
            未登録の方は、リアルタイムアンケートに答えてからか、または、「今すぐ自分も相談してみる」から会員登録を行います。
          </li>
          <li>
            【STEP2】リアルタイムアンケートを毎月5問以上回答<br />
            毎月更新されるリアルタイムアンケートに5問以上回答すると5Pontaポイントの加算対象となります。
          </li>
        </ol>
        <h3>◆ポイント加算時期</h3>
        <p>
          リアルタイムアンケートを月に5問以上回答された方には後日、オカネコ for
          Pontaの登録アドレス宛にポイント獲得のためのエントリーURLとユニークコードが送付されます。そちらのページからエントリーの手続きをして頂いた方にはエントリー完了の翌月末までに登録しているPonta会員IDにポイントが加算されます。詳細は送付されるエントリーページをご確認ください。ポイント加算は、諸事情により遅延する場合もございます。予めご了承ください。加算ポイントはPontaWebのポイント通帳にてご確認いただけます。
        </p>
        <h3>◆特典内容</h3>
        <p>
          本ページからオカネコの会員登録を完了して、上記ポイント獲得条件を満たすことでポイント獲得。
        </p>
        <h3>◆【重要】端末・ブラウザ設定に関する注意事項</h3>
        <p>※ブラウザのCookie、Javascript、SSLの設定を有効にしてください。</p>
        <h3>◆注意事項</h3>
        <ul>
          <li>
            回答数が月5問に満たない場合、会員登録が完了していない場合は加算対象となりませんのでご注意ください。
          </li>
          <li>
            PontaWebログインにはPontaWeb会員登録が必要です。PontaWeb会員登録の際にはPonta会員IDとリクルートIDのご登録が必要です。
          </li>
          <li>
            Ponta会員IDの登録内容に虚偽・不備がある場合は、ポイント加算対象外となります。
          </li>
          <li>
            対象期間中、ポイント加算時点までに以下の条件に当てはまった場合、Pontaポイント獲得の権利を失います。
            <ul>
              <li>ポイント加算までにPontaを退会された場合</li>
              <li>リクルートIDを退会された場合</li>
              <li>PontaWeb会員登録（Ponta会員IDの登録）が行われていない場合</li>
            </ul>
          </li>
          <li>
            景品表示法の定めにより、当選者は(株)ロイヤリティマーケティングが実施するその他キャンペーンの対象外とさせていただく場合がございます。
          </li>
          <li>
            その他、(株)ロイヤリティマーケティング、（株）リクルート、(株)400Fが不正とみなしたPonta会員は対象外とさせていただきます。
          </li>
          <li>
            「Pontaポイント」プレゼントのため、cookieを利用しております。以下のような場合は正常にポイント加算ができませんのでご注意ください。
            <ul>
              <li>ブラウザのcookie設定を有効にしていない</li>
              <li>
                各サイトへ遷移後、登録手続き等が完了する前に別のウェブサイトを開く
              </li>
              <li>各サイトへ遷移後、別のブラウザを開いて手続きを進める</li>
            </ul>
          </li>
          <li>
            インターネット通信料・接続料などの費用はお客様のご負担となります。
          </li>
          <li>システム障害その他の理由でサービスを停止する場合があります。</li>
          <li>
            アクセス集中や通信回線の状態による遅延、不具合などにより本サービスへのアクセスや登録・表示などができないことにより発生した損害、または起因して発生したすべての事象につきましては、原因の如何によらず一切の責任を負いかねますので、あらかじめご了承ください。
          </li>
        </ul>

        <h3>◆お問い合わせ</h3>
        <ul>
          <li>
            <a
              href="https://faq.ponta.jp/as/scope3/ponta/pontaweb_sp/"
              :target="target"
              :rel="rel"
            >
              Pontaについてはこちら</a
            >
          </li>
          <li>
            <a
              href="https://help.point.recruit.co.jp/s"
              :target="target"
              :rel="rel"
              >リクルートIDについてはこちら</a
            >
          </li>
        </ul>
        <template #promotion>
          <h3>◆キャンペーン概要</h3>
          <p>
            オカネコ for
            Pontaに会員登録をし、本ページから毎月8問リアルタイムアンケートに回答で、通常は5問回答で5Pontaポイントをプレゼントのところ、20倍の100Pontaポイントをプレゼントいたします。
          </p>
          <h3>◆キャンペーン期間</h3>
          <p>2023年10月1日(日)～2023年12月31日(日)</p>
          <h3>◆ポイント獲得条件</h3>
          <ol>
            <li>
              【STEP1】まずはオカネコ for Pontaの会員登録を完了<br />
              未登録の方は、リアルタイムアンケートに答えてから、または、「診断をはじめる(無料)」から会員登録を行います。
            </li>
            <li>
              【STEP2】リアルタイムアンケートを毎月8問回答<br />
              毎週更新されるリアルタイムアンケートに月8問回答するとキャンペーン期間中は100Pontaポイントの加算対象となります。
            </li>
          </ol>
          <h3>◆ポイント加算時期</h3>
          <p>
            リアルタイムアンケートを月に8問回答された方には翌月末頃までに、オカネコ
            for
            Pontaの登録アドレス宛にポイント獲得のためのエントリーURLとユニークコードが送付されます。そちらのメールからエントリーページへアクセスして、エントリーの手続きをしていただいた方にはエントリー完了の翌月末頃までに登録しているPonta会員IDにポイントが加算されます。
          </p>
          <p>詳細はエントリーページをご確認ください。</p>
          <p>
            ポイント加算は、諸事情により遅延する場合もございます。予めご了承ください。加算ポイントはPontaWebのポイント通帳もしくは、au
            Ponta ポータルのポイント履歴に てご確認いただけます。
          </p>
          <h3>◆特典内容</h3>
          <p>
            本ページからオカネコの会員登録を完了して、上記ポイント獲得条件を満たすことでポイント獲得。
          </p>
          <h3>◆【重要】端末・ブラウザ設定に関する注意事項</h3>
          <p>※ブラウザのCookie、Javascript、SSLの設定を有効にしてください。</p>
          <h3>◆注意事項</h3>
          <ul>
            <li>
              回答数が月8問に満たない場合、会員登録が完了していない場合は加算対象となりませんのでご注意ください。
            </li>
            <li>
              ポイント加算のためのエントリーにはPonta会員IDとリクルートIDもしくはau
              IDのご登録が必要です。
            </li>
            <li>
              Ponta会員IDの登録内容に虚偽・不備がある場合は、ポイント加算対象外となります。
            </li>
            <li>
              対象期間中、ポイント加算時点までに以下の条件に当てはまった場合、Pontaポイント獲得の権利を失います。
              <ul>
                <li>ポイント加算までにPontaを退会された場合</li>
                <li>リクルートIDを退会された場合</li>
                <li>au IDを退会された場合</li>
              </ul>
            </li>
            <li>
              景品表示法の定めにより、当選者は(株)ロイヤリティマーケティングが実施するその他キャンペーンの対象外とさせていただく場合がございます。
            </li>
            <li>
              その他、(株)ロイヤリティ
              マーケティング、(株)リクルート、KDDI(株)、(株)400Fが不正とみなしたPonta会員は対象外とさせていただきます。
            </li>
            <li>
              「Pontaポイント」プレゼントのため、cookieを利用しております。以下のような場合は正常にポイント加算ができませんのでご注意ください。
              <ul>
                <li>ブラウザのcookie設定を有効にしていない</li>
                <li>
                  各サイトへ遷移後、登録手続き等が完了する前に別のウェブサイトを開く
                </li>
                <li>各サイトへ遷移後、別のブラウザを開いて手続きを進める</li>
              </ul>
            </li>
            <li>
              インターネット通信料・接続料などの費用はお客様のご負担となります。
            </li>
            <li>
              システム障害その他の理由でサービスを停止する場合があります。
            </li>
            <li>
              アクセス集中や通信回線の状態による遅延、不具合などにより本サービスへのアクセスや登録・表示などができないことにより発生した損害、または起因して発生したすべての事象につきましては、原因の如何によらず一切の責任を負いかねますので、あらかじめご了承ください。
            </li>
          </ul>

          <h3>◆お問い合わせ</h3>
          <ul>
            <li>
              <a
                href="https://faq.ponta.jp/as/scope3/ponta/pontaweb_sp/"
                :target="target"
                :rel="rel"
              >
                Pontaについてはこちら</a
              >
            </li>
            <li>
              <a
                href="https://help.point.recruit.co.jp/s"
                :target="target"
                :rel="rel"
                >リクルートIDについてはこちら</a
              >
            </li>
            <li>
              <a
                href="https://id.auone.jp/id/pc/help/"
                :target="target"
                :rel="rel"
                >au IDについてはこちら</a
              >
            </li>
          </ul>
        </template>
      </PromotionWithPeriod>
    </div>
  </section>
</template>

<style lang="scss" module>
.section {
  &__contents {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }
}

.title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}

.description {
  h3 {
    font-size: 14px;

    &:nth-of-type(n + 2) {
      margin-top: 24px;
    }
  }

  ol {
    list-style: none;

    & > *:nth-child(n + 2) {
      margin-top: 24px;
    }
  }

  ul {
    padding-left: 22px;
  }

  ul {
    list-style-type: disc;
  }

  a {
    color: $color-text-and-object-accent-primary;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
